import React from 'react';
import { InputText } from 'components/inputText/inputText';

const { formatText } = require('core/i18n').i18n;

export const CompanyNameInput = ({
    profileModel,
    label,
    handleOnFocus,
    isValidated,
    userProfileForm,
    userProfile,
    formActions,
}) => (
    <InputText
        profileModel={profileModel}
        label={label}
        validations={{
            required: value => value && value.length,
            minLength: value => value && value.length > 2,
            maxLength: value => value && value.length <= 60,
        }}
        messagesError={{
            required: formatText('validation-notValidCompanyName'),
            minLength: formatText('validation-minLengthCompanyName'),
            maxLength: formatText('validation-maxLengthCompanyName'),
        }}
        isValidated={isValidated}
        focusAnimated
        onFocus={handleOnFocus}
        userProfileForm={userProfileForm}
        userProfile={userProfile}
        formActions={formActions}
    />
);
